import { defineAction } from '~/prix'
import citizenHealthProfileFetchAction from './citizenHealthProfileFetch.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const citizenHealthProfileFetchDefinition = defineAction({
  ...citizenHealthProfileFetchAction,

  input: z.object({
    healthProfessionalCnes: z.string().nullish(),
    citizenNameSearch: z.string().nullish(),
    lastUpdate: dateOrIsoString()
      .transform(value => new Date(value))
      .nullish(),
    offset: z.number().optional(),
  }),
  output: z.object({}),
})

export default citizenHealthProfileFetchDefinition
